import { Link } from 'react-router-dom';
import { HOME_PATH } from '../../utils/constant';
import './index.css';

type BrandMarkProps = {
  asLink?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

export default function BrandMark({ asLink = true, size = 'md' }: BrandMarkProps) {
  const mark = (
    <span className={`bs-brand-mark bs-brand-mark--${size}`} aria-label="Buffstreams">
      <span className="bs-brand-mark__glow" aria-hidden="true" />
      <span className="bs-brand-mark__text">
        <span className="bs-brand-mark__buff">Buff</span>
        <span className="bs-brand-mark__streams">streams</span>
      </span>
    </span>
  );

  if (!asLink) return mark;

  return (
    <Link to={HOME_PATH} className="bs-brand-mark-link">
      {mark}
    </Link>
  );
}
